import React from "react";
import { Formik, Form } from "formik";
import { CreateUserSchema, ResetPasswordSchema } from "../../forms/schema";
import { IconTextInput } from "../../forms/components";
import DataTable from "../../components/DataTable";

import {
	createResellerUser,
	removeUser,
	resetUserPassword,
} from "../../libs/functions";

import Util from "../../libs/util";

import Swal from "sweetalert2";

class ManageUserModal extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			targetUser: undefined,
		};
	}

	handleCreate = (values, { setSubmitting, resetForm }) => {
		Swal.fire({
			title: "Creating User",
			onBeforeOpen: () => {
				Util.hideModal("create-user").then(() => {
					resetForm();
				});
				Swal.showLoading();
			},
			onOpen: async () => {
				try {
					let status = await createResellerUser({
						...values,
						reseller: this.props.reseller,
					});
					if (status) {
						setSubmitting(false);
						Swal.fire({
							icon: "success",
							title: "User Created",
							onClose: () => {
								this.props.retrieveUsers(this.props.reseller);
								Util.showModal("manage-users");
							},
						});
					}
				} catch (err) {
					setSubmitting(false);
					if (err.response) {
						if (err.response.status === 401) {
							Util.expireSession().then(() => {
								window.location = "/login";
							});
						} else {
							Swal.fire({
								icon: "error",
								title: `Unable to Create user`,
								onClose: () => {
									Util.showModal("manage-users");
								},
							});
						}
					}
				}
			},
		});
	};

	openResetModal = (user) => {
		this.setState({ targetUser: user });
		Util.showModal("reset-password").then(() => {});
	};

	handleReset = (values, { setSubmitting, resetForm }) => {
		const { targetUser } = this.state;
		Swal.fire({
			title: "Resetting User Password",
			onBeforeOpen: () => {
				Util.hideModal("reset-password").then(() => {
					resetForm();
				});
				Swal.showLoading();
			},
			onOpen: async () => {
				try {
					let status = await resetUserPassword({
						...values,
						user: targetUser._id,
					});
					if (status) {
						setSubmitting(false);
						Swal.fire({
							icon: "success",
							title: "User Password Resetted",
							onClose: () => {
								this.props.retrieveUsers(this.props.reseller);
								Util.showModal("manage-users");
							},
						});
					}
				} catch (err) {
					setSubmitting(false);
					if (err.response) {
						if (err.response.status === 401) {
							Util.expireSession().then(() => {
								window.location = "/login";
							});
						} else {
							Swal.fire({
								icon: "error",
								title: `Unable to Reset User Password`,
								onClose: () => {
									Util.showModal("manage-users");
								},
							});
						}
					}
				}
			},
		});
	};

	removeUser = (userId) => {
		Util.promptConfirmation().then((result) => {
			if (result.value) {
				Swal.fire({
					title: "Removing User",
					allowOutsideClick: false,
					allowEscapeKey: false,
					onBeforeOpen: () => {
						Swal.showLoading();
					},
					onOpen: async () => {
						try {
							let status = await removeUser(userId);
							if (status) {
								Swal.fire({
									icon: "success",
									title: `User removed!`,
								}).then(() => {
									this.props.retrieveUsers(this.props.reseller);
								});
							} else {
								Swal.fire({
									icon: "error",
									title: "Unauthorised",
								});
							}
						} catch (err) {
							console.log(err);
							if (err.response.status === 401) {
								Util.expireSession().then(() => {
									window.location = "/login";
								});
							} else {
								Swal.fire({
									icon: "error",
									title: `Unable to Remove User`,
									onClose: () => {},
								});
							}
						}
					},
				});
			}
		});
	};

	render() {
		const { users, reseller } = this.props;
		return (
			<>
				<div id="manage-users" className="uk-modal-container">
					<div className="uk-modal-dialog uk-modal-body">
						<h2 className="uk-modal-title">Manage Users</h2>
						<div className="users uk-margin-medium-bottom">
							<h4 className="uk-margin-remove">
								<span className="uk-flex uk-flex-middle">
									<i
										className="uk-margin-small-right form-header-icon"
										uk-icon="icon: fa-solid-users; ratio: 0.9"
									/>
									Users
									<button
										className="uk-margin-left uk-icon-button uk-button-primary"
										uk-icon="icon: fa-solid-user-plus; ratio: 0.5"
										uk-tooltip="Create User"
										type="button"
										uk-toggle="target: #create-user"
									/>
									<button
										className="uk-margin-small-left uk-icon-button uk-button-primary"
										uk-icon="icon: fa-solid-sync-alt; ratio: 0.5"
										uk-tooltip="Refresh List"
										type="button"
									/>
								</span>
								<hr className="uk-margin-small-top uk-margin-small-bottom" />
							</h4>
							{users && users.length > 0 && (
								<DataTable
									className="uk-table uk-table-hover uk-table-striped uk-table-responsive"
									options={{ dom: "t", ordering: false }}
								>
									<thead>
										<tr>
											<th />
											<th className="uk-table-shrink">No.</th>
											<th>Username</th>
											<th>Email</th>
											<th className="uk-width-1-5">Created At</th>
											<th className="uk-width-1-5 uk-text-center">Action</th>
										</tr>
									</thead>
									<tbody>
										{users.map((user, index) => {
											return (
												<tr key={index}>
													<td className="icon-column">
														<button
															className="uk-icon-button uk-button-danger"
															uk-icon="icon: fa-solid-minus; ratio: 0.5"
															type="button"
															onClick={() => this.removeUser(user._id)}
														/>
													</td>

													<td>{index + 1}</td>
													<td>{user.username}</td>
													<td>{user.email}</td>
													<td>{Util.toDateTimeString(user.createdAt)}</td>
													<td>
														<button
															className="uk-button uk-button-small uk-button-primary uk-width-1-1 action-btn"
															type="button"
															onClick={() => this.openResetModal(user)}
														>
															<span className="uk-text-middle uk-text-bold">
																Reset Password
															</span>
														</button>
													</td>
												</tr>
											);
										})}
									</tbody>
								</DataTable>
							)}
						</div>
					</div>
				</div>
				<div
					id="create-user"
					className="uk-modal-container"
					uk-modal="bg-close: false"
				>
					<div className="uk-modal-dialog uk-modal-body">
						<h2 className="uk-modal-title">
							Create User for {reseller && reseller.name}
						</h2>
						<Formik
							initialValues={CreateUserSchema.initialValues}
							validationSchema={CreateUserSchema.validation}
							onSubmit={this.handleCreate}
						>
							{(props) => (
								<Form className="uk-form-stacked" onSubmit={props.handleSubmit}>
									<IconTextInput
										icon="user"
										label="Username"
										id="username"
										name="username"
										type="text"
										placeholder=""
									/>
									<IconTextInput
										icon="mail"
										label="Email Address"
										id="email"
										name="email"
										type="email"
										placeholder=""
									/>
									<IconTextInput
										icon="lock"
										label="Password"
										id="password"
										name="password"
										type="password"
										autoComplete="new-password"
										placeholder=""
									/>
									<IconTextInput
										icon="lock"
										label="Confirm Password"
										id="cpassword"
										name="cpassword"
										type="password"
										autoComplete="new-password"
										placeholder=""
									/>
									<p className="uk-text-right">
										<button
											className="uk-button uk-button-default"
											type="button"
											onClick={() => {
												props.resetForm();
												Util.hideModal("create-user").then(() => {
													Util.showModal("manage-users").then(() => {});
												});
											}}
										>
											Cancel
										</button>
										<button
											className="uk-button uk-button-primary"
											type="submit"
										>
											Create
										</button>
									</p>
								</Form>
							)}
						</Formik>
					</div>
				</div>
				<div
					id="reset-password"
					className="uk-modal-container"
					uk-modal="bg-close: false"
				>
					<div className="uk-modal-dialog uk-modal-body">
						<h2 className="uk-modal-title">Reset Password</h2>
						<Formik
							initialValues={ResetPasswordSchema.initialValues}
							validationSchema={ResetPasswordSchema.validation}
							onSubmit={this.handleReset}
						>
							{(props) => (
								<Form className="uk-form-stacked" onSubmit={props.handleSubmit}>
									<IconTextInput
										icon="lock"
										label="New Password"
										id="npassword"
										name="npassword"
										type="password"
										autoComplete="new-password"
										placeholder=""
									/>
									<IconTextInput
										icon="lock"
										label="Confirm Password"
										id="rpassword"
										name="rpassword"
										type="password"
										autoComplete="new-password"
										placeholder=""
									/>
									<p className="uk-text-right">
										<button
											className="uk-button uk-button-default"
											type="button"
											onClick={() => {
												props.resetForm();
												Util.hideModal("reset-password").then(() => {
													Util.showModal("manage-users").then(() => {});
												});
											}}
										>
											Cancel
										</button>
										<button
											className="uk-button uk-button-primary"
											type="submit"
										>
											Reset
										</button>
									</p>
								</Form>
							)}
						</Formik>
					</div>
				</div>
			</>
		);
	}
}

export default ManageUserModal;
